import React, { useMemo, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { vesselServices } from "../services/vessels.services";
import { useDispatch } from "react-redux";
import { alertActions } from "../../_actions";
import { alertConstants } from "../../_constants";
import classes from "../assets/css/vessels.module.css";
import { decrypt, encrypt, history } from "../../_helpers";

export default function CopyVessel({
  vesselId,
  toggle,
  show,
  vessel,
  userId,
  publicKey,
  secretKey,
  userPrivateKey,
  userPublicKey,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [decryptedVessel, setDecryptedVessel] = useState({});

  useMemo(() => {
    setDecryptedVessel({
      sheetName: `${decrypt(vessel?.sheetName, publicKey, secretKey)} (copie)`,
      vesselName: decrypt(vessel?.vesselName, publicKey, secretKey),
      vesselIMO: decrypt(vessel?.vesselIMO, publicKey, secretKey),
      vesselRegistryPort: decrypt(
        vessel?.vesselRegistryPort,
        publicKey,
        secretKey
      ),
      vesselFlag: decrypt(vessel?.vesselFlag, publicKey, secretKey),
      vesselType: decrypt(vessel?.vesselType, publicKey, secretKey),
      vesselLOA: decrypt(vessel?.vesselLOA, publicKey, secretKey),
      vesselMaxPassengersWithStaterooms: decrypt(
        vessel?.vesselMaxPassengersWithStaterooms,
        publicKey,
        secretKey
      ),
      vesselDayPassengersOnBoard: decrypt(
        vessel?.vesselDayPassengersOnBoard,
        publicKey,
        secretKey
      ),
      vesselServiceProvider: decrypt(
        vessel?.vesselServiceProvider,
        publicKey,
        secretKey
      ),
      vesselServiceProviderAddress: decrypt(
        vessel?.vesselServiceProviderAddress,
        publicKey,
        secretKey
      ),
      vesselServiceProviderCompany: decrypt(
        vessel?.vesselServiceProviderCompany,
        publicKey,
        secretKey
      ),
      vesselServiceProviderInsuranceRef: decrypt(
        vessel?.vesselServiceProviderInsuranceRef,
        publicKey,
        secretKey
      ),
      vesselServiceProviderVAT: decrypt(
        vessel?.vesselServiceProviderVAT,
        publicKey,
        secretKey
      ),
      vesselCentralAgent: decrypt(
        vessel?.vesselCentralAgent,
        publicKey,
        secretKey
      ),
      vesselCentralAgentAddress: decrypt(
        vessel?.vesselCentralAgentAddress,
        publicKey,
        secretKey
      ),
      vesselCentralAgentCompany: decrypt(
        vessel?.vesselCentralAgentCompany,
        publicKey,
        secretKey
      ),
      vesselCentralAgentInsuranceRef: decrypt(
        vessel?.vesselCentralAgentInsuranceRef,
        publicKey,
        secretKey
      ),
      vesselCentralAgentVAT: decrypt(
        vessel?.vesselCentralAgentVAT,
        publicKey,
        secretKey
      ),
      vesselCentralAgentMYBA: decrypt(
        vessel?.vesselCentralAgentMYBA,
        publicKey,
        secretKey
      ),
      vesselStakeholder: decrypt(
        vessel?.vesselStakeholder,
        publicKey,
        secretKey
      ),
      vesselStakeholderAddress: decrypt(
        vessel?.vesselStakeholderAddress,
        publicKey,
        secretKey
      ),
      vesselStakeholderCompany: decrypt(
        vessel?.vesselStakeholderCompany,
        publicKey,
        secretKey
      ),
      vesselStakeholderInsuranceRef: decrypt(
        vessel?.vesselStakeholderInsuranceRef,
        publicKey,
        secretKey
      ),
      vesselStakeholderMYBA: decrypt(
        vessel?.vesselStakeholderMYBA,
        publicKey,
        secretKey
      ),
      vesselStakeholderVAT: decrypt(
        vessel?.vesselStakeholderVAT,
        publicKey,
        secretKey
      ),
      vesselStakeholderFinancialGuarantee: decrypt(
        vessel?.vesselStakeholderFinancialGuarantee,
        publicKey,
        secretKey
      ),
      vesselSpecialConditions: decrypt(
        vessel?.vesselSpecialConditions,
        publicKey,
        secretKey
      ),
    });
  }, [vessel]);
  const handleChange = (e) => {
    setDecryptedVessel({
      ...decryptedVessel,
      sheetName: e.target.value,
    });
  };
  const handleCopy = async () => {
    try {
      setIsLoading(true);
      const payload = {
        sheetName: encrypt(
          decryptedVessel?.sheetName,
          userPublicKey,
          userPrivateKey
        ),
        vesselName: encrypt(
          decryptedVessel?.vesselName,
          userPublicKey,
          userPrivateKey
        ),
        vesselIMO: encrypt(
          decryptedVessel?.vesselIMO,
          userPublicKey,
          userPrivateKey
        ),
        vesselRegistryPort: encrypt(
          decryptedVessel?.vesselRegistryPort,
          userPublicKey,
          userPrivateKey
        ),
        vesselFlag: encrypt(
          decryptedVessel?.vesselFlag,
          userPublicKey,
          userPrivateKey
        ),
        vesselType: encrypt(
          decryptedVessel?.vesselType,
          userPublicKey,
          userPrivateKey
        ),
        vesselLOA: encrypt(
          decryptedVessel?.vesselLOA,
          userPublicKey,
          userPrivateKey
        ),
        vesselMaxPassengersWithStaterooms: encrypt(
          decryptedVessel?.vesselMaxPassengersWithStaterooms,
          userPublicKey,
          userPrivateKey
        ),
        vesselDayPassengersOnBoard: encrypt(
          decryptedVessel?.vesselDayPassengersOnBoard,
          userPublicKey,
          userPrivateKey
        ),
        vesselServiceProvider: encrypt(
          decryptedVessel?.vesselServiceProvider,
          userPublicKey,
          userPrivateKey
        ),
        vesselServiceProviderAddress: encrypt(
          decryptedVessel?.vesselServiceProviderAddress,
          userPublicKey,
          userPrivateKey
        ),
        vesselServiceProviderCompany: encrypt(
          decryptedVessel?.vesselServiceProviderCompany,
          userPublicKey,
          userPrivateKey
        ),
        vesselServiceProviderInsuranceRef: encrypt(
          decryptedVessel?.vesselServiceProviderInsuranceRef,
          userPublicKey,
          userPrivateKey
        ),
        vesselServiceProviderVAT: encrypt(
          decryptedVessel?.vesselServiceProviderVAT,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgent: encrypt(
          decryptedVessel?.vesselCentralAgent,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgentAddress: encrypt(
          decryptedVessel?.vesselCentralAgentAddress,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgentCompany: encrypt(
          decryptedVessel?.vesselCentralAgentCompany,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgentInsuranceRef: encrypt(
          decryptedVessel?.vesselCentralAgentInsuranceRef,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgentVAT: encrypt(
          decryptedVessel?.vesselCentralAgentVAT,
          userPublicKey,
          userPrivateKey
        ),
        vesselCentralAgentMYBA: encrypt(
          decryptedVessel?.vesselCentralAgentMYBA,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholder: encrypt(
          decryptedVessel?.vesselStakeholder,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderAddress: encrypt(
          decryptedVessel?.vesselStakeholderAddress,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderCompany: encrypt(
          decryptedVessel?.vesselStakeholderCompany,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderInsuranceRef: encrypt(
          decryptedVessel?.vesselStakeholderInsuranceRef,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderMYBA: encrypt(
          decryptedVessel?.vesselStakeholderMYBA,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderVAT: encrypt(
          decryptedVessel?.vesselStakeholderVAT,
          userPublicKey,
          userPrivateKey
        ),
        vesselStakeholderFinancialGuarantee: encrypt(
          decryptedVessel?.vesselStakeholderFinancialGuarantee,
          userPublicKey,
          userPrivateKey
        ),
        vesselSpecialConditions: encrypt(
          decryptedVessel?.vesselSpecialConditions,
          userPublicKey,
          userPrivateKey
        ),
      };
      const response = await vesselServices?.copy(vesselId, userId, payload);
      history.push(`/vessels/edit/${response?.id}`);
      dispatch(
        alertActions.setAlert(t(response?.message), alertConstants.SUCCESS)
      );
    } catch (error) {
      setIsLoading(false);
      dispatch(alertActions.setAlert(t(error), alertConstants.ERROR));
    }
  };

  return (
    <>
      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title className={classes.modalTitle}>
            {t("Duplicate vessel")}
            <br />
            {decrypt(vessel?.sheetName, publicKey, secretKey)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={decryptedVessel?.sheetName}
            onChange={handleChange}
            placeholder="Enter a sheet name"
            required
          />
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <Button onClick={handleCopy} disabled={isLoading}>
            {t("Duplicate")}
          </Button>
          <Button onClick={toggle}>{t("Cancel")}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
